import { useFetchData } from "../../../hooks/useFetch";
import { User as UserRequest } from "../../../models/request/user";
import { User } from "../../../models/response/user/user";
import { API_EMPLOYEE_ROUTER } from "../../../services/api-config";

export const EmployeeService = {
  changeEmployeePassword: () => {
    const { request, baseResponse, loading } = useFetchData.Post();
    return {
      fetch: (
        id: string,
        data: { old_password: string; new_password: string }
      ) =>
        request({
          endPoint: API_EMPLOYEE_ROUTER.API_CHANGE_PASSWORD_EMPLOYEE(id),
          data,
        }),
      response: baseResponse,
      loading: loading,
    };
  },

  getEmployeeDetail: () => {
    const { request, baseResponse, loading } = useFetchData.Get<User>();
    return {
      fetch: (id: string) =>
        request({
          endPoint: API_EMPLOYEE_ROUTER.API_GET_EMPLOYEE_DETAIL(id),
        }),
      response: baseResponse,
      loading: loading,
    };
  },

  updateEmployee: () => {
    const { request, baseResponse, loading } = useFetchData.Post<User>();
    return {
      fetch: (id: string, data: Partial<UserRequest>) =>
        request({
          endPoint: API_EMPLOYEE_ROUTER.API_UPDATE_EMPLOYEE(id),
          data,
        }),
      response: baseResponse,
      loading: loading,
    };
  },

  update2fa: () => {
    const { request, baseResponse, loading } = useFetchData.Post<User>();
    return {
      fetch: () =>
        request({
          endPoint: API_EMPLOYEE_ROUTER.API_UPDATE_2FA(),
        }),
      response: baseResponse,
      loading: loading,
    };
  },
};
